import React from 'react';
import { MultiColumnPanel } from './view/multiColumnPanel3';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'MultiColumnPanel3', 
  itemElt: (item, cmsOption) => <MultiColumnPanel item={item} cmsOption={cmsOption} />
}